import Repository from "../../repository";

export default {
    Stations: (payload) => Repository.post(`/api/AquaCharts/Stations`, payload),
    Nodes: (payload) => Repository.post(`/api/AquaCharts/Nodes`, payload),
}